import './BPMFileInput.scss';
import { ComponentProps, memo } from 'react';
import { Button } from '../Button/Button';
import { Appearance, AppearanceType, Size } from '../designConstants';

interface FileInputProps extends Omit<ComponentProps<typeof Button>, 'appearance'> {
  buttonText?: string;
  id: string;
  name: string;
  onChange: any;
  accept?: string;
  appearance?: AppearanceType;
}

export const BPMFileInput = memo<FileInputProps>(
  ({
    buttonText = 'Add File',
    className,
    id,
    name,
    onChange,
    accept,
    appearance = Appearance.OUTLINED,
    ...passthrough
  }) => (
    <div className={`bpm-file-input ${className}`}>
      <Button
        size={Size.LG}
        {...passthrough}
        appearance={appearance}
        className={`bpm-file-input-inner-button ${className}`}
      >
        <label htmlFor={id} className='bpm-file-input-inner-label'>
          {buttonText}
        </label>
      </Button>
      <input
        className={`bpm-file-input-inner-input-element ${className}`}
        type='file'
        name={name}
        id={id}
        onChange={onChange}
        accept={accept}
      />
    </div>
  )
);
